import { render, staticRenderFns } from "./Correct.vue?vue&type=template&id=285ba14d&scoped=true&"
import script from "./Correct.vue?vue&type=script&lang=js&"
export * from "./Correct.vue?vue&type=script&lang=js&"
import style0 from "./Correct.vue?vue&type=style&index=0&id=285ba14d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285ba14d",
  null
  
)

export default component.exports